// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__30Im4","itemTitle":"ClientEmergencyInfo_itemTitle__Qr3GP","itemText":"ClientEmergencyInfo_itemText__2pElv"};